import { render, staticRenderFns } from "./VehicleDrivesWidget.vue?vue&type=template&id=a3c489ce&scoped=true&"
import script from "./VehicleDrivesWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleDrivesWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDrivesWidget.vue?vue&type=style&index=0&id=a3c489ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c489ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3c489ce')) {
      api.createRecord('a3c489ce', component.options)
    } else {
      api.reload('a3c489ce', component.options)
    }
    module.hot.accept("./VehicleDrivesWidget.vue?vue&type=template&id=a3c489ce&scoped=true&", function () {
      api.rerender('a3c489ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleDrivesWidget.vue"
export default component.exports